import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const updateCompanyBranchStatus = async (id, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-branch/update/status/${id}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateCompanyBranchStatus - error", error)
        return handleApiError(error)
    }
}

export const getSingleBranch = async (id) => {
    const data = {
        branchId: id
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-branch/getBranchById`, data);
        return await response.data;
    } catch (error) {
        console.log("getSingleBranch - error", error)
        return handleApiError(error)
    }
}

export const getBranchListByCompany = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-branch/getBranchByCompanyId/${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getListByCompany - error", error)
        return handleApiError(error)
    }
}

export const getBranchesList = async (data) => {
    try {
        console.log(data)
        const response = await axios.post(`${REACT_APP_API_URL}/company-branch/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBranchesList - error", error)
        return handleApiError(error)
    }
}

export const getCompanyBranchById = async (branchId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-branch/${branchId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyBranchById - error", error)
        return handleApiError(error)
    }
}

export const addCompanyBranchData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-branch/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addCompanyBranch - error", error)
        return handleApiError(error)
    }
}

export const updateCompanyBranchData = async (branchId, data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-branch/${branchId}`, data)
        return await response.data
    } catch (error) {
        console.log("updateCompanyBranch - error", error)
        return handleApiError(error)
    }
}